import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "system-item" }
const _hoisted_2 = ["src"]

import { PropType } from 'vue';
import { useStore } from 'vuex';
import { System } from '@/models/system.model';
import { HardwareComponent } from '@/models/hardware.model';
import Case from '@/components/system/components/Case.vue';
import Motherboard from '@/components/system/components/Motherboard.vue';
import PowerSupply from '@/components/system/components/PowerSupply.vue';
import CPU from '@/components/system/components/CPU.vue';
import CPUCooler from '@/components/system/components/CPUCooler.vue';
import Memory from '@/components/system/components/Memory.vue';
import GPU from '@/components/system/components/GPU.vue';
import Monitor from '@/components/system/components/Monitor.vue';
import GenericComponent from '@/components/system/components/GenericComponent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'System',
  props: {
  system: {
    type: Object as PropType<System>,
    required: true,
  },
},
  setup(__props) {

const { system } = __props;

const store = useStore();


const getComponent = (id: number): HardwareComponent | null => {
  return (
    store.state.hardwareComponents.find(
      (c: HardwareComponent) => c.id === id,
    ) || null
  );
};

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (__props.system)
    ? (_openBlock(), _createBlock(_component_RouterLink, {
        key: 0,
        to: `/system/${__props.system.slug}`
      }, {
        default: _withCtx(() => [
          _createElementVNode("section", _hoisted_1, [
            _createElementVNode("img", {
              src: `/images/${__props.system.image}`,
              width: "170"
            }, null, 8, _hoisted_2),
            _createElementVNode("div", null, [
              _createElementVNode("h2", null, _toDisplayString(__props.system.name), 1),
              _createElementVNode("ul", null, [
                _createVNode(Case, {
                  component: getComponent(__props.system.case)
                }, null, 8, ["component"]),
                _createVNode(Motherboard, {
                  component: getComponent(__props.system.motherboard)
                }, null, 8, ["component"]),
                _createVNode(PowerSupply, {
                  component: getComponent(__props.system.powersupply),
                  full: ""
                }, null, 8, ["component"]),
                _createVNode(CPU, {
                  component: getComponent(__props.system.cpu)
                }, null, 8, ["component"]),
                _createVNode(CPUCooler, {
                  component: getComponent(__props.system.cpucooler)
                }, null, 8, ["component"]),
                _createVNode(Memory, {
                  component: getComponent(__props.system.memory)
                }, null, 8, ["component"]),
                _createVNode(GPU, {
                  component: getComponent(__props.system.gpu)
                }, null, 8, ["component"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.system.otherComponents, (c) => {
                  return (_openBlock(), _createBlock(GenericComponent, {
                    component: getComponent(c)
                  }, null, 8, ["component"]))
                }), 256)),
                _createVNode(Monitor, {
                  component: getComponent(__props.system.monitor)
                }, null, 8, ["component"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["to"]))
    : _createCommentVNode("", true)
}
}

})